const API_BASE = process.env.REACT_APP_TENANT_API || 'https://htb4wmezrg.execute-api.us-west-2.amazonaws.com/prod';

export const getMSPConfig = async (slug) => {
  const response = await fetch(`${API_BASE}/v2/msp/config?slug=${slug}`);
  if (!response.ok) {
    throw new Error('MSP not found');
  }
  return response.json();
};

export const getMSPTenants = async (mspID) => {
  const response = await fetch(`${API_BASE}/v2/msp/tenants?mspID=${mspID}`);
  if (!response.ok) {
    throw new Error('Failed to fetch tenants');
  }
  return response.json();
};

export const getMSPUsers = async (mspID) => {
  const response = await fetch(`${API_BASE}/v2/msp/users?mspID=${mspID}`);
  if (!response.ok) {
    throw new Error('Failed to fetch MSP users');
  }
  return response.json();
};

export const inviteMSPUser = async (mspID, email, accessLevel) => {
  const response = await fetch(`${API_BASE}/v2/msp/users/invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mspID, email, accessLevel })
  });
  if (!response.ok) {
    throw new Error('Failed to invite user');
  }
  return response.json();
};

export const createTenantForMSP = async (mspID, customerEmail, customerName) => {
  const response = await fetch(`${API_BASE}/v2/msp/tenants/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mspID, customerEmail, customerName })
  });
  if (!response.ok) {
    throw new Error('Failed to create tenant');
  }
  return response.json();
};

export const assignTenantToMSP = async (mspID, tenantID) => {
  const response = await fetch(`${API_BASE}/v2/msp/tenants/assign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mspID, tenantID })
  });
  if (!response.ok) {
    throw new Error('Failed to assign tenant');
  }
  return response.json();
};